export const avatar_text = {
  fontFamily: 'Poppins',
  fontSize: '16px',
  fontWeight: '400',
  color: 'rgba(38, 38, 38, 1)',
};

export const typography_UI = {
  fontSize: '16px',
  fontFamily: 'poppins',
  fontWeight: '400',
  color: '#666666',
};

export const tabs = {
  '&.MuiTab-root': {
    fontFamily: 'poppins',
    textTransform: 'capitalize',
    overflow: 'unset',
  },
};
export const showfont = {
  fontFamily: 'Poppins ',
  fontWeight: '300',
  fontSize: '14px',
};
export const avatar_subtext = {
  fontFamily: 'Poppins',
  fontSize: '12px',
  fontWeight: '300',
  color: '#666666',
};
